module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAAAAXNSR0IArs4c6QAAAGJJREFUOE/dk6EVgDAQQ5OOQBEIBKPQrsJOHI6hEBgEooIpGmz1ycb/iJ8XDuuxhaAZjrDWwjHZDWpy8JBY6AFbpoeCmO2ksLhcUA9j3o2AawUAbw8SXfIaiDHZRfq+APH7AVzFFt7D5Js5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/Vector2.png
// module id = nXz1
// module chunks = 74